import CustomTabs from "../../../../../ui/tabs/CustomTabs";
import SimDaAttivare from "./sim-da-attivare/SimDaAttivare";
import OfferteConsip from "./offerte/OfferteConsip";

const OrdiniConsipTabs = ({selectedTab, setSelectedTab}) => {
    const handleTabChange = (e, tab) => {
        setSelectedTab(tab)
    }

    const tabs = [
        {
            title: "Offerte",
            subtitle: "",
            component: <OfferteConsip/>
        },
        {
            title: "Device",
            subtitle: "",
            component: <></>
        },
        {
            title: "Servizi aggiuntivi",
            subtitle: "",
            component: <></>
        },
        {
            title: "SIM da attivare",
            subtitle: "",
            component: <SimDaAttivare />
        }
    ]

    return (
        <CustomTabs tabs={tabs}
                    handleTabChange={(e, value) => handleTabChange(e, value)}
                    selectedTab={selectedTab}/>
    )
}

export default OrdiniConsipTabs;